<template>
	<vx-card id="company-card-main">
		<div slot="no-body" class="tabs-container px-6 pt-6">
			<vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
				<vs-tab :label="$t('DesignConfig.ListOfTypeConfig')" icon-pack="feather" icon="icon-list">
					<div class="tab-text">
						<type-config-crud-list-view
							v-if="typeConfigReadPermission"
							class="mt-4"
							@selectedCompanyEmit="selectedCompanyEmit"
						/>
						<not-permission v-else></not-permission>
					</div>
				</vs-tab>
				<vs-tab :label="tabLabelText" icon-pack="feather" icon="icon-info">
					<div class="tab-text">
						<configuration-design
							v-if="typeConfigCreatePermission && this.typeConfiguration.id == 0"
							:schema="typeConfiguration"
							@changeActiveTabEmit="changeActiveTab"
							@consultTypeConfigEmit="consultTypeConfig"
						/>

						<configuration-design
							v-else-if="typeConfigUpdatePermission && this.typeConfiguration.id !== 0"
							:schema="typeConfiguration"
							@changeActiveTabEmit="changeActiveTab"
							@consultTypeConfigEmit="consultTypeConfig"
						/>

						<not-permission v-else></not-permission>
					</div>
				</vs-tab>
			</vs-tabs>
			<router-view></router-view>
		</div>
	</vx-card>
</template>

<script>
import CompanyConf from "@/models/CompanyConf.js";
import TypeConfigCrudListView from "./TypeConfigCrudListView.vue";
import moduleTypeConfigCrud from "@/store/type-config-crud/moduleTypeConfigCrud.js";
import NotPermission from "@/views/pages/NotPermission.vue";
import ConfigurationDesign from "./ConfigurationDesign.vue";
import TypeConfiguration from "../../models/TypeConfiguration";

export default {
	name: "TypeConfigCrud",
	data() {
		return {
			company: new CompanyConf({}),
			activeTab: 0,
			typeConfiguration: new TypeConfiguration({}),
		};
	},
	components: {
		TypeConfigCrudListView,
		NotPermission,
		ConfigurationDesign,
	},
	computed: {
		// Define el nombre del primer tab según la acción a realizar
		tabLabelText() {
			if (this.company.type_config_id !== 0) {
				return this.$t("DesignConfig.UpdateTypeConfig");
			} else {
				return this.$t("DesignConfig.NewTypeConfig");
			}
		},
		typeConfigReadPermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_R");
		},
		typeConfigCreatePermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_C");
		},
		typeConfigUpdatePermission() {
			return this.$store.getters.checkPermission("TYPE_CONFIG_U");
		},
	},
	methods: {
		// Seleccion de editar
		selectedCompanyEmit(val) {
			this.typeConfiguration = new TypeConfiguration(val);
			this.activeTab = 1;
		},
		// Cambiar tab actual
		changeActiveTab(tabNum) {
			this.activeTab = tabNum;
			this.company = new CompanyConf(0, {});
			this.typeConfiguration = new TypeConfiguration({});
		},
		loading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		consultTypeConfig() {
			this.loading();
			// Consulta los tipos de configuración existentes

			this.$store
				.dispatch("moduleTypeConfigCrud/getListConfig")
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
	},
	created() {
		// Se registra el modulo
		if (!moduleTypeConfigCrud.isRegistered) {
			this.$store.registerModule("moduleTypeConfigCrud", moduleTypeConfigCrud);
			moduleTypeConfigCrud.isRegistered = true;
		}
		this.consultTypeConfig();
	},
};
</script>
